import { fromJS } from 'immutable'
import {
  CLIENT_MASTER_DELETE_REQUEST,
  CLIENT_MASTER_DELETE_SUCCESS,
  CLIENT_MASTER_DELETE_FAILURE,
  CLIENT_MASTER_DELETE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CLIENT_MASTER_DELETE_REQUEST:
      return state
        .set('isFetching', true)
    case CLIENT_MASTER_DELETE_SUCCESS:
      return state
        .set('isFetching', false)
        .set('deletedClient', fromJS(action.payload.deletedClient))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
    case CLIENT_MASTER_DELETE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('deletedClient', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case CLIENT_MASTER_DELETE_RESET:
      return state
        .delete('deletedClient')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/client/client-master-delete-reducer.js